import React, { Component } from "react"
import PropTypes from "prop-types"
import "./content-editable.css"
import { sanitizeHTML } from "utils/sanitize-html"

export class ContentEditable extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    className: PropTypes.string,
    content: PropTypes.string,
    editing: PropTypes.bool,
    name: PropTypes.string,
    style: PropTypes.object,
    tag: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.node = React.createRef()
  }

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.content !== this.content() ||
      nextProps.style !== this.props.style
    )
  }

  content = () => {
    if (
      Array.from(this.node.current).some(
        child => child.nodeType !== Node.TEXT_NODE
      )
    ) {
      return this.node.current.innerHTML
    } else {
      return this.node.current.textContent
    }
  }

  handleChange = () => {
    this.props.onChange && this.props.onChange({ content: this.content() })
  }

  render() {
    const Tag = this.props.tag

    const classes = this.props.className || ""
    const contentEditableProps = this.props.editing
      ? {
          className: classes.concat(" core-content-editable").trim(),
          contentEditable: true
        }
      : { className: classes }

    return (
      <Tag
        ref={this.node}
        {...contentEditableProps}
        data-element={this.props.name}
        data-testid={this.props.name}
        style={this.props.style}
        onBlur={this.handleChange}
        onClick={this.props.onClick}
        onPaste={e => {
          e.preventDefault()

          let text = (e.originalEvent || e).clipboardData.getData("text/plain")

          this.node.current.innerHTML = text
        }}
        dangerouslySetInnerHTML={{
          __html: sanitizeHTML(this.props.content)
        }}
      />
    )
  }
}
